import { checkEmptyVal, checkObjNullorEmpty } from "../utils/common";
import { SessionStorageKeys } from "../utils/constants";

function addSessionStorageItem(key, val) {
  sessionStorage.setItem(key, val);
}

// Get item
function getsessionStorageItem(key, defaultVal = "") {
  let item = sessionStorage.getItem(key);
  if (checkEmptyVal(item) && checkObjNullorEmpty(item)) {
    return defaultVal;
  } else {
    return item;
  }
}

// Remove item
function deletesessionStorageItem(key) {
  sessionStorage.removeItem(key);
}

// Clear all
function clearsessionStorage() {
  sessionStorage.clear();
}

// Get keys length
function getsessionStorageKeysLength() {
  return sessionStorage.length;
}

// Get key name
function getsessionStorageKeyName(index) {
  return sessionStorage.key(0);
}

function clearAllStorage() {
  localStorage.clear();
  sessionStorage.clear();
}

// Save the list's current grid page before a row action leaves the list.
function saveGridPaging(path, pagingInfo) {
  addSessionStorageItem(
    SessionStorageKeys.GridPagingInfo,
    JSON.stringify({ path: path, pi: pagingInfo?.pi, ps: pagingInfo?.ps })
  );
}

// Saved grid page for this list path, or null when it was saved by another list.
function getGridPaging(path) {
  try {
    let paging = JSON.parse(
      getsessionStorageItem(SessionStorageKeys.GridPagingInfo, "{}")
    );
    return paging.path === path && paging.pi >= 0 && paging.ps > 0
      ? { pi: paging.pi, ps: paging.ps }
      : null;
  } catch (err) {
    return null;
  }
}

function clearGridPaging() {
  deletesessionStorageItem(SessionStorageKeys.GridPagingInfo);
}

export {
  addSessionStorageItem,
  getsessionStorageItem,
  deletesessionStorageItem,
  clearsessionStorage,
  getsessionStorageKeysLength,
  getsessionStorageKeyName,
  clearAllStorage,
  saveGridPaging,
  getGridPaging,
  clearGridPaging,
};
